import React, { useEffect, useState } from "react";

const CareerAddEditModal = ({ isOpen, onClose, onSave, initialData }) => {
  const emptyForm = {
    title: "",
    location: "",
    type: "Full-time",
    posted: "",
    salary: "",
    description: "",
  };

  const [form, setForm] = useState(emptyForm);

  useEffect(() => {
    if (!isOpen) return;
    if (initialData) {
      setForm({ ...initialData });
    } else {
      setForm({ ...emptyForm, posted: new Date().toISOString().slice(0, 10) });
    }
  }, [isOpen, initialData]);

  function handleSubmit(e) {
    e.preventDefault();
    if (!form.title.trim() || !form.salary.trim()) {
      // simple client side validation: require title and salary
      alert("Please provide title and salary.");
      return;
    }

    onSave({ ...form });
  }

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm">
      <div className="bg-white rounded-2xl w-full max-w-2xl p-6 shadow-2xl ring-1 ring-slate-100">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-xl font-semibold">
            {initialData ? "Edit Job" : "Add Job"}
          </h2>
          <button onClick={onClose} className="text-slate-600">
            ✕
          </button>
        </div>

        <form
          onSubmit={handleSubmit}
          className="grid grid-cols-1 md:grid-cols-2 gap-4"
        >
          <div className="col-span-1 md:col-span-2">
            <label className="block text-sm font-medium text-slate-700">
              Job Title
            </label>
            <input
              value={form.title}
              onChange={(e) =>
                setForm((f) => ({ ...f, title: e.target.value }))
              }
              className="mt-1 w-full border rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#5989C8] focus:border-transparent"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-slate-700">
              Location
            </label>
            <input
              value={form.location}
              onChange={(e) =>
                setForm((f) => ({ ...f, location: e.target.value }))
              }
              className="mt-1 w-full border rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#5989C8] focus:border-transparent"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-slate-700">
              Type
            </label>
            <select
              value={form.type}
              onChange={(e) => setForm((f) => ({ ...f, type: e.target.value }))}
              className="mt-1 w-full border rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#5989C8] focus:border-transparent"
            >
              <option>Full-time</option>
              <option>Part-time</option>
              <option>Contract</option>
              <option>Internship</option>
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium text-slate-700">
              Posted Date
            </label>
            <input
              type="date"
              value={form.posted}
              onChange={(e) =>
                setForm((f) => ({ ...f, posted: e.target.value }))
              }
              className="mt-1 w-full border rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#5989C8] focus:border-transparent"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-slate-700">
              Salary / Stipend
            </label>
            <input
              value={form.salary}
              onChange={(e) =>
                setForm((f) => ({ ...f, salary: e.target.value }))
              }
              className="mt-1 w-full border rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#5989C8] focus:border-transparent"
            />
          </div>

          <div className="col-span-1 md:col-span-2">
            <label className="block text-sm font-medium text-slate-700">
              Description
            </label>
            <textarea
              value={form.description}
              onChange={(e) =>
                setForm((f) => ({ ...f, description: e.target.value }))
              }
              rows={3}
              className="mt-1 w-full border rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#5989C8] focus:border-transparent"
            />
          </div>

          <div className="col-span-1 md:col-span-2 flex items-center justify-end gap-3">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 rounded-lg border"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-4 py-2 rounded-lg bg-gradient-to-r from-[#5989C8] to-[#064585] text-white"
            >
              Save Job
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CareerAddEditModal;
